var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "mask",
        rawName: "v-mask",
        value: { mask: _vm.mask, greedy: false, showMaskOnHover: false },
        expression: "{ mask, greedy: false, showMaskOnHover: false }",
      },
    ],
    ref: "input",
    attrs: {
      id: _vm.id,
      type: "text",
      autocomplete: "off",
      name: _vm.name,
      placeholder: _vm.placeholder,
    },
    domProps: { value: _vm.value },
    on: { change: _vm.handleChange, input: _vm.valueUpdated },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }